import { render } from "./web-login.vue?vue&type=template&id=14725be6&scoped=true"
import script from "./web-login.vue?vue&type=script&lang=js"
export * from "./web-login.vue?vue&type=script&lang=js"

import "./web-login.vue?vue&type=style&index=0&id=14725be6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14725be6"]])

export default __exports__